import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbAccordionModule, NgbDatepickerModule, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {LeadFormComponent} from './lead-form/lead-form.component';
import {BrowserModule} from '@angular/platform-browser';
import {CtaFormComponent} from './cta-form.component';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {LeadFormHeaderComponent} from './lead-form/lead-form-header/lead-form-header.component';
import {
  CheckboxModule,
  ComboBoxDropdownModule,
  ComboBoxModule,
  CountrySelectorModule,
  InputModule,
  NgDesignSystemModule,
  TextareaModule,
  TextSearchHighlightModule,
  TooltipModule
} from 'ng-design-system';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MediaModule} from '@spartacus/storefront';
import {LeadFormSuccessComponent} from './lead-form/lead-form-success/lead-form-success.component';
import {LeadFormErrorComponent} from './lead-form/lead-form-error/lead-form-error.component';
import {
  CountrySwitchModalModule
} from '../../layout/header/country-selector/country-switch-modal/country-switch-modal.module';
import {LeadFormLoginComponent} from './lead-form/lead-form-login/lead-form-login.component';
import {
  LeadFormUserLoginComponent
} from './lead-form/lead-form-login/lead-form-user-login/lead-form-user-login.component';
import {ValidatorsModule} from '../../directives/validators/validators.module';
import {AnalyticsDirectivesModule} from '../../directives/analytics/analytics-directives.module';
import {
  LeadFormCompanyDetailsComponent
} from './lead-form/lead-form-company-details/lead-form-company-details.component';
import {
  LeadFormPartnerDetailsComponent
} from './lead-form/lead-form-partner-details/lead-form-partner-details.component';
import {
  LeadFormProductDetailsComponent
} from './lead-form/lead-form-product-details/lead-form-product-details.component';
import {LeadFormUserStatusComponent} from './lead-form/lead-form-user-status/lead-form-user-status.component';
import {A11yModule} from '@angular/cdk/a11y';
import {
  LeadFormContractDetailsComponent
} from './lead-form/lead-form-contract-details/lead-form-contract-details.component';
import {FormlyDatePickerModule} from '../../shared/formly/fields/duration/date-picker/formly-date-picker.module';
import {CtaButtonComponent} from './cta-button/cta-button.component';
import {RECAPTCHA_BASE_URL, RecaptchaModule} from 'ng-recaptcha';
import {
  CtaInfoPageOpenButtonComponent
} from './cta-info-page/cta-info-page-open-button/cta-info-page-open-button.component';
import {CtaInfoPageModalComponent} from './cta-info-page/cta-info-page-modal/cta-info-page-modal.component';
import {
  CtaInfoPageCtaButtonComponent
} from './cta-info-page/cta-info-page-cta-button/cta-info-page-cta-button.component';
import {AutofocusModule} from '@app/directives/autofocus/autofocus.module';
import {CtaInfoPageCtaLinkComponent} from './cta-info-page/cta-info-page-cta-link/cta-info-page-cta-link.component';
import {DcpDateFormatterModule} from '@dcp/configurator';

@NgModule({
  declarations: [
    CtaFormComponent,
    LeadFormComponent,
    LeadFormHeaderComponent,
    LeadFormSuccessComponent,
    LeadFormErrorComponent,
    LeadFormLoginComponent,
    LeadFormCompanyDetailsComponent,
    LeadFormUserLoginComponent,
    LeadFormPartnerDetailsComponent,
    LeadFormContractDetailsComponent,
    LeadFormProductDetailsComponent,
    LeadFormUserStatusComponent,
    CtaButtonComponent,
    CtaInfoPageOpenButtonComponent,
    CtaInfoPageModalComponent,
    CtaInfoPageCtaButtonComponent,
    CtaInfoPageCtaLinkComponent,
  ],
  imports: [
    CommonModule,
    NgbAccordionModule,
    BrowserModule,
    NgbModule,
    I18nModule,
    InputModule,
    CountrySelectorModule,
    TextareaModule,
    CheckboxModule,
    ComboBoxDropdownModule,
    ComboBoxModule,
    TextSearchHighlightModule,
    FormsModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductCallToActionComponent: {
          component: CtaFormComponent
        }
      }
    }),
    CountrySwitchModalModule,
    ValidatorsModule,
    A11yModule,
    AnalyticsDirectivesModule,
    FormlyDatePickerModule,
    NgDesignSystemModule,
    ReactiveFormsModule,
    TooltipModule,
    DcpDateFormatterModule,
    NgbDatepickerModule,
    RecaptchaModule,
    AutofocusModule,
  ],
  exports: [
    CtaFormComponent,
    LeadFormComponent,
  ],
  providers: [
    {
      provide: RECAPTCHA_BASE_URL,
      useValue: 'https://recaptcha.net/recaptcha/api.js',
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CtaFormModule {
}
